import { IBaseModel, BaseModel } from '../base.model';

export interface IBMParticipantEditedViewModel extends IBaseModel {
  fk_entity: number,
  presence: string,
  summon_next_meeting: boolean,
  pid: string
}
export class BMParticipantEditedViewModel extends BaseModel implements IBMParticipantEditedViewModel {
  fk_entity: number
  presence: string
  summon_next_meeting: boolean
  pid: string

  constructor (entity: number = null, presence: string = 'P', summon: boolean = false) {
    super()
    this.fk_entity = entity
    this.presence = presence
    this.summon_next_meeting = summon
    this.pid = null
  }
}



// WEBPACK FOOTER //
// ./src/models/bm/bm-participant-edited.viewmodel.ts